module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs-getting"
  }, [_c('div', {
    staticClass: "tabs-getting__container"
  }, [_c('div', {
    staticClass: "tabs-getting__cards"
  }, _vm._l((_vm.props), function(tab, i) {
    return _c('div', {
      staticClass: "tabs-getting__card"
    }, [_c('div', {
      staticClass: "tabs-getting__box"
    }, [_c('div', {
      staticClass: "tabs-getting__step"
    }, [_vm._v(_vm._s(i + 1))])]), _c('div', {
      staticClass: "tabs-getting__title",
      domProps: {
        "innerHTML": _vm._s(tab.title)
      }
    }), _c('div', {
      staticClass: "tabs-getting__content",
      domProps: {
        "innerHTML": _vm._s(tab.content)
      }
    }), (i === 0) ? _c('div', {
      staticClass: "tabs-getting__modal tabs-getting__button",
      on: {
        "click": function($event) {
          _vm.modal = true
        }
      }
    }, [_vm._v("Request Appointment")]) : _vm._e(), _vm._l((tab.forms), function(form) {
      return (i === 1) ? _c('div', {
        staticClass: "tabs-getting__forms tabs-getting__button"
      }, [_c('a', {
        attrs: {
          "href": form.link,
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(form.button_text))])]) : _vm._e()
    })], 2)
  }))]), _c('ModalRequestAppointment', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.modal),
      expression: "modal"
    }],
    on: {
      "close": function($event) {
        _vm.modal = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-737fe85a","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/tabs/tabs-getting/tabs-getting.pug
// module id = 539
// module chunks = 1